import { request, localConfig, combineUrl } from '~/common';

const docRequest = (params, callback, action) => {
    return request(combineUrl(localConfig.obtApiUrl, `Document/V1/json/${action}`), params, callback);
}

export function SearchInvoice(params, callback) {
    return docRequest(params, callback, 'SearchInvoice');
}

export function RequestDownloadInvoice(params, callback) {
    return docRequest(params, callback, 'RequestDownloadInvoice');
}

export function SearchDownloadInvoice(params, callback) {
    return docRequest(params, callback, 'SearchDownloadInvoice');
}

const docFileRequest = (params, callback, action) => {
    return request(combineUrl(localConfig.obtApiUrl, `Document/V1/json/${action}`), params, callback, { file: true });
}

export function DownloadInvoice(params, callback) {
    return docFileRequest(params, callback, 'DownloadInvoice');
}

export function DownloadInvoicesZip(params, callback) {
    return docFileRequest(params, callback, 'DownloadInvoicesZip');
}